import axios from 'axios';
import { API_URL } from 'constantes/constantes';

export async function getEvents({endpoint}) {

  const apiURL = API_URL + `${endpoint}.json`;

  const config = {
      method: 'get',
      url: apiURL,
      timeout: 25000,
      withCredentials: false,
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json; charset=utf-8'
      }
  }

  try {
      const response = await axios(config);

      if (response.status === 200) {
          return { data: response.data, statusCode: 200 };
      } else if (response.status === 404) {
          // Recurso no encontrado
          return { statusCode: 404, data: [] };
      } else {
          // Otro código de estado, manejar según sea necesario
          return { statusCode: response.status, data: [] };
      }
  } catch (error) {
      // Manejar errores de la petición
      console.error("Error en la petición:", error);
      return { statusCode: 404, data: [] };
  }
}